import { SizeDefinition } from "./SizeDefinition";
import { Macro } from "./Macro";

export interface IPlacement {
    id?: number
    path?: string
    name?: string
    refresh?: number
    macroId?: number
    sizeDefinitions?: SizeDefinition[]
}

export class Placement implements IPlacement {
    id: number;
    dateCreated: Date;
    path: string;
    name: string;
    refresh: number;
    macroId: number;
    macro: Macro;
    sizeDefinitions: SizeDefinition[];

    constructor()
    constructor(obj: IPlacement)
    constructor(obj?: IPlacement) {
        this.path = obj && obj.path || undefined;
        this.name = obj && obj.name || undefined;
        this.refresh = obj && obj.refresh || undefined;
        this.macroId = obj && obj.macroId || undefined;
        this.sizeDefinitions = obj && obj.sizeDefinitions || undefined;
    }
}


